<template>
  <div class="c-avatar-list">
    <div class="c-avatar-list__wrapper">
      <h3 class="o-typography__headline3">
        {{ $t('subscriber.profile.chooseAvatar') }}
      </h3>

      <div class="c-avatar-list__container">
        <div
          v-for="avatar in avatars"
          :key="avatar.url"
          class="c-avatar-list__avatar"
          @click="choose(avatar)"
        >
          <img
            :src="avatar.url"
            :alt="avatar.name"
          >
        </div>

        <div
          class="c-avatar-list__avatar c-avatar-list__avatar--empty"
          @click="choose"
        >
          <span class="icon-noacess"></span>
        </div>
      </div>
    </div>

    <span
      class="c-avatar-list__icon-close o-icon o-icon--close o-typography--action"
      @click="close"
    ></span>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        name: '',
        list: [],
        subscriber: this.$services.resolve('subscriber'),
        avatarResource: this.$services.resolve('avatars'),
        profiles: this.$services.resolve('profiles'),
      };
    },
    computed: {
      avatars() {
        const used = this.profiles.collection.records.map((profile) => profile.avatar.id);
        return this.list.filter((avatar) => used.indexOf(avatar.id) === -1);
      },
    },
    mounted() {
      this.load();
    },
    methods: {
      load() {
        if (this.avatarResource.collection.isFetched) {
          this.list = this.avatarResource.collection.records;
        } else {
          this.avatarResource.fetchAll().then(() => {
            this.list = this.avatarResource.collection.records;
          });
        }
      },
      choose(avatar) {
        this.$emit('choose', avatar);
      },
      close() {
        this.$emit('close');
      },
    },
  };
</script>
